// This controller borrows from toggle_controller.js and does some additional stuff specific to
// multi-select.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "overlay", "content"];

  connect() {
    this.update();
  }

  toggle(e) {
    // There's a limitation in height animations, which is nothing to do with Tailwind, just CSS.
    // If you want to animate, you have to have a specific start and end size.  To make this happen
    // We use an arbitrarily large max-height which should be big enough to accommodate the content.
    this.contentTarget.classList.toggle("max-h-0");
    this.contentTarget.classList.toggle("max-h-[1000px]");

    this.overlayTarget.classList.toggle("hidden");
  }

  update(e) {
    var display = "";
    var checkboxes = this.element.querySelectorAll("input[type=checkbox]");
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        if (display.length > 0) {
          display += ", ";
        }

        display += checkboxes[i].value;
      }
    }

    if (display.length == 0) {
      display = "All";
    }

    this.displayTarget.value = display;
  }
}
